import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { CustomerListNameCell } from './customer-list-name.cell';
import { CustomerListNameHeader } from './customer-list-name.header';

export const CustomerListNameColumn: IdentifiedColumnDef<
  GatewayCustomerModel,
  GatewayCustomerModel['name']
> = {
  enableSorting: false,
  header: CustomerListNameHeader,
  cell: CustomerListNameCell,
};
